import styled from "styled-components";
import { deviceDF } from "utils/breakPoints";
import { BLUE_RGB } from "utils/colorsTheme";

export const ColumnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  flex-wrap: wrap;
  @media ${deviceDF.tablet} {
    flex-direction: column;
  }
`;

// Styles Mui
export const styles = () => ({
  thTable: {
    fontSize: ".875rem",
    fontWeight: "bold",
    color: BLUE_RGB,
  },
});
